import { render } from "./StyledInfoWithIcon.vue?vue&type=template&id=6ae0fdf2&scoped=true"
import script from "./StyledInfoWithIcon.vue?vue&type=script&lang=js"
export * from "./StyledInfoWithIcon.vue?vue&type=script&lang=js"

import "./StyledInfoWithIcon.vue?vue&type=style&index=0&id=6ae0fdf2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ae0fdf2"]])

export default __exports__